import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");

  if (!token && !role) {
    return <Navigate to="/" replace />; // Redirect to AdminLogin
  }

  return <Outlet />; // Render the protected children
};

export default ProtectedRoute;
